import React, { useMemo } from "react";
import { MEDIA } from "../lib/media";

export function StarField({ count = 60 }) {
  const stars = useMemo(
    () =>
      Array.from({ length: count }).map((_, i) => ({
        id: i,
        top: Math.random() * 65,
        left: Math.random() * 100,
        size: Math.random() * 2 + 1,
        delay: Math.random() * 4,
        dur: 2 + Math.random() * 3,
      })),
    [count]
  );
  return (
    <div className="pointer-events-none absolute inset-0 overflow-hidden" aria-hidden="true">
      {stars.map((s) => (
        <span
          key={s.id}
          className="star absolute rounded-full bg-white"
          style={{
            top: `${s.top}%`,
            left: `${s.left}%`,
            width: `${s.size}px`,
            height: `${s.size}px`,
            animationDelay: `${s.delay}s`,
            animationDuration: `${s.dur}s`,
            boxShadow: "0 0 6px rgba(255,255,255,0.8)",
          }}
        />
      ))}
    </div>
  );
}

// Glowing moon overlay (controllable size + light).
export function Moon() {
  return (
    <div
      className="pointer-events-none absolute right-[27%] top-[14%] z-[6] h-[58px] w-[58px] sm:h-[86px] sm:w-[86px]"
      aria-hidden="true"
      style={{
        borderRadius: "50%",
        transform: "translateX(-19px)",
        boxShadow:
          "0 0 26px 8px rgba(255,226,150,0.5), 0 0 70px 26px rgba(255,214,120,0.32), 0 0 130px 55px rgba(255,200,90,0.16)",
      }}
    >
      <img
        src={MEDIA.moon}
        alt=""
        className="h-full w-full rounded-full object-cover"
        style={{ transform: "scale(1.02)", filter: "sepia(0.55) saturate(1.5) hue-rotate(-12deg) brightness(1.05)" }}
      />
    </div>
  );
}

// Shooting star / comet.
export function ShootingStar() {
  return (
    <div className="shooting-star pointer-events-none absolute left-[2%] top-[8%] z-10" aria-hidden="true">
      <span className="shooting-star-dot" />
    </div>
  );
}

// Elegant Santa sleigh + reindeer silhouette (SVG, transparent, guaranteed crisp).
export function SantaSleigh() {
  return (
    <div
      className="santa-sleigh pointer-events-none absolute left-0 top-[12%] z-10 w-[220px] sm:w-[300px]"
      aria-hidden="true"
    >
      <svg viewBox="0 0 400 120" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full drop-shadow-[0_2px_10px_rgba(212,175,55,0.35)]">
        <g fill="#0B132B" stroke="#D4AF37" strokeWidth="1.4">
          {/* Sleigh body */}
          <path d="M20 78 C18 62 34 60 52 60 L96 60 C104 60 108 66 106 74 L104 84 C103 90 98 92 92 92 L34 92 C26 92 21 86 20 78 Z" />
          <path d="M18 92 C10 92 8 84 16 82 L104 82 C112 82 112 92 104 94 L24 94" fill="none" />
          {/* Santa */}
          <circle cx="60" cy="50" r="8" fill="#8B0000" stroke="#D4AF37" strokeWidth="1" />
          <path d="M52 60 C52 52 68 52 68 60 Z" fill="#8B0000" stroke="none" />
          {/* Gift sack */}
          <path d="M74 60 C72 48 96 48 94 62 C94 70 74 70 74 60 Z" fill="#1B4D3E" />
        </g>
        {/* Reins */}
        <path d="M106 70 C160 58 210 58 250 66" stroke="#D4AF37" strokeWidth="1" opacity="0.6" fill="none" />
        {/* Reindeer 1 */}
        <g fill="#0B132B" stroke="#D4AF37" strokeWidth="1.2" transform="translate(240,44)">
          <path d="M0 24 L4 8 L10 8 L14 24 L26 24 L30 8 L36 8 L40 24 L36 34 L4 34 Z" />
          <path d="M40 20 C48 18 52 12 50 6" fill="none" />
          <path d="M50 6 l-4 -8 M50 6 l4 -6 M54 0 l2 -6 M46 -2 l-3 -6" stroke="#D4AF37" strokeWidth="1" fill="none" />
        </g>
        {/* Reindeer 2 */}
        <g fill="#0B132B" stroke="#D4AF37" strokeWidth="1.2" transform="translate(310,42)">
          <path d="M0 24 L4 8 L10 8 L14 24 L26 24 L30 8 L36 8 L40 24 L36 34 L4 34 Z" />
          <path d="M40 20 C48 18 52 12 50 6" fill="none" />
          <path d="M50 6 l-4 -8 M50 6 l4 -6 M54 0 l2 -6 M46 -2 l-3 -6" stroke="#D4AF37" strokeWidth="1" fill="none" />
          <circle cx="52" cy="18" r="2.5" fill="#C8102E" stroke="none" />
        </g>
      </svg>
    </div>
  );
}
